module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('big', [_vm._v("M")]), _vm._v("y mother and dad gave me just about everything a boy, young man, and a man could have been given: their love, strict rules that were to be obeyed, and the desire to carry on what looks like a genetic disposition of the Keith family to serve our country.")], 1), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My dad served in the U.S. Navy, and fought in World War II and Korea and my Uncle, Richard Keith, served as a U.S. Marine in both Korea and Vietnam, but they were not the first of the family to serve their country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My grandfather, James Keith, an army sergeant in World War I, fought in France. My great, great grandfather, John B. Keith fought on the Confederate side in the Civil War, and Cornelius Keith fought with Francis Marion, known, as “the Swamp Fox,” in the Revolutionary War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My cousin Brian Keith was always ready to help me with my many computer glitches and researching family history. Brian also checked and double checked dates, names, and all of the details that helped me put the facts in order as I wrote the book.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I would also like to thank Pete Wolverton, Associate Publisher at Thomas Dunne Books, and our production editor Bob Berkel. They both made this a better book.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter02"
    }
  }), _vm._v("Acknowledgments")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of my closest friends, Steve Schwarzer, the master bladesmith, encouraged me to tell the story that would become this book. He also introduced me to Terry Riebling, my coauthor. Starting with just a list of "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("chapters Terry made sure that the book was what I wanted it to be. Thanks to his hard work the book turned out better than I thought it would. Terry has become a close and trusted friend.")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7266587b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 75
// module chunks = 0